/**
 * @typedef {Object} BusinessAppStateSettingKeys
 * @property {boolean} showContactButton
 */

export const initialSettings = {
  showContactButton: false,
};

/**
 * @type {BusinessAppStateSettingKeys}
 */
export const inputLabels = (() => {
  const target = {};
  for (const setting in initialSettings) {
    if (Object.hasOwn(initialSettings, setting)) {
      target[setting] = setting;
    }
  }
  return target;
})();

export function settingsReducer(state, action) {
  return {
    ...state,
    [action.name]: action.value === 'default' ? undefined : action.value,
  };
}

/**
 * Synchronous initial reducer state from the page's own blok, so SSG/SSR output already
 * reflects this setting instead of the hardcoded `false` default — BusinessLayout.jsx's
 * dispatchSetting effect still runs afterward for editor live-preview.
 * @param {*} blok
 * @returns {BusinessAppStateSettingKeys}
 */
export function buildInitialSettings(blok = {}) {
  return {
    ...initialSettings,
    showContactButton: blok.showContactButton || false,
  };
}
